import { deckItemComponents } from './deck-item.js';
import { deckSectionComponents } from './deck-section.js';
import { deckComponents } from './deck.js';
import { handrailEndComponents } from './handrail-end.js';
import { projectedEntityComponents } from './projected-entity.js';
import { stairsComponents } from './stairs.js';
export const generatedComponents = [
    ...deckComponents,
    ...deckItemComponents,
    ...projectedEntityComponents,
    ...deckSectionComponents,
    ...handrailEndComponents,
    ...stairsComponents
];

//# sourceMappingURL=index.js.map